import { render, staticRenderFns } from "./StaffRoles.vue?vue&type=template&id=90448b7a&"
import script from "./StaffRoles.vue?vue&type=script&lang=js&"
export * from "./StaffRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports